import { format as d3Format, formatLocale } from 'd3-format';
import createNumberFormatter from '../createNumberFormatter';
export default function createD3NumberFormatter({
  format,
  locale,
  id,
  label,
  description
}) {
  let formatFunc;
  let isInvalid = false;

  try {
    formatFunc = typeof locale === 'undefined' ? d3Format(format) : formatLocale(locale).format(format);
  } catch (error) {
    formatFunc = value => value + " (Invalid format: " + format + ")";

    isInvalid = true;
  }

  return createNumberFormatter(formatFunc, {
    id: id != null ? id : format,
    label,
    description,
    isInvalid
  });
}